<script setup lang="ts">
import { default as PTabMenu } from 'primevue/tabmenu'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CSchoolUpdate from '@/presentation/components/schools/CSchoolUpdate.vue'

const router = useRouter()
const route = useRoute()

const props = defineProps<{
  loading: boolean
  schoolSlug?: string
}>()

const activeTab = ref('Informations générales')

const items = ref([
  createTabItem('Informations générales', false),
  createTabItem('Périodes scolaires'),
  createTabItem('Gestion des utilisateurs'),
  createTabItem('Gestion des classes et groupes')
])

// METHODS
const onTabChange = (e: string) => {
  activeTab.value = e
  router.push({ query: { tab: e } })
}

function createTabItem(label: string, disabled = true) {
  return {
    label,
    command: () => {
      onTabChange(label)
    },
    disabled: disabled
  }
}

// COMPUTED
const tabDisplay = computed(() => {
  switch (activeTab.value) {
    case 'Informations générales':
      return CSchoolUpdate
    case 'Périodes scolaires':
      return 'div'
    case 'Gestion des utilisateurs':
      return 'div'
    case 'Gestion des classes et groupes':
      return 'div'
    case 'Gestion des parcours':
      return 'div'
    default:
      return 'div'
  }
})

onMounted(() => {
  if (route.query.tab) {
    activeTab.value = router.currentRoute.value.query.tab as string
  } else {
    router.push({ query: { tab: activeTab.value } })
  }
})
</script>

<template>
  <div>
    <p-tab-menu :model="items" />
  </div>

  <component :is="tabDisplay" :loading="loading" :schoolSlug="schoolSlug" />
</template>
